/* eslint-disable no-unused-expressions */
import { createGlobalStyle } from 'styled-components';
import elements from 'shared/styles/elements';
import generic from 'shared/styles/generic';
import vendor from 'shared/styles/vendor';

const globalStyle = createGlobalStyle`
  ${generic};
  ${elements};
  ${vendor};
`;

export default globalStyle;
